import React, { Component } from 'react';
import '../styles/layout/footer.scss';

class Footer extends Component {
    render() {
        return (
            <div>
            <div className="Footer">
                <br/>
                        <hr/>
                    <p>&copy; {new Date().getFullYear()} - Vision Trak Rentals Pty Ltd</p>
            </div>   
            </div>
        );
    }
}

export default Footer;